import { Swiper } from 'swiper/bundle';

var swipers = document.querySelectorAll('.js-cards-swiper');

swipers.forEach((swiper) => {
  initializeSwiper(swiper);
});


function initializeSwiper(swiperInstance) {
  const slides = Array.from(swiperInstance.querySelector('.swiper-wrapper').children);

  slides.forEach((slide) => {
    slide.classList.add('swiper-slide');
  });
  
  new Swiper(swiperInstance, {
    speed: 500,
    slidesPerView: 1,
    spaceBetween: 20,
    simulateTouch: false,
    navigation: {
      nextEl: '.swiper-button-next > button',
      prevEl: '.swiper-button-prev > button',
    },
    pagination: {
      el: '.swiper-pagination',
      clickable: true,
    },
    breakpoints: {
      320: {
        slidesPerView: 1,
      },
      768: {
        slidesPerView: 2,
      },
      992: {
        slidesPerView: 3,
      },
      1200: {
        slidesPerView: 4,
      },
    },
  });
}

export { initializeSwiper };
